import { useQueryClient, useMutation } from '@tanstack/react-query';
import { deleteFirebaseItem } from '../api/deleteFirebaseItem.ts';
import { COLLECTIONS } from '../constants';
import { Filter } from '../api/getFirestoreItemByQuery.ts';

export const useDeleteFirebaseItem = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      id,
      collection,
    }: {
      id: string;
      collection?: string;
      filters?: Filter[];
    }) => deleteFirebaseItem(id, collection),
    onSuccess: (_, { collection, id, filters }) => {
      const _collection = collection || COLLECTIONS.listings;
      queryClient.invalidateQueries({ queryKey: [_collection, id] });
      queryClient.invalidateQueries({ queryKey: [_collection, filters] });
    },
  });
};
